import CryptoJS from 'crypto-js'
/**
 * @word 要加密的内容
 * @keyWord String  服务器随机返回的关键字
 *  */
export function aesEncrypt(word, keyWord = 'ajcaptcha') {
  // 如果 keyWord 为空，使用默认密钥
  const key = keyWord || 'ajcaptcha'
  var keyHex = CryptoJS.enc.Utf8.parse(key)
  var srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, keyHex, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
  return encrypted.toString()
}
